import React, { Component } from 'react';
import DatePicker from './DatePicker';

class SimpleDatePicker extends Component {
  state = {
    isFocused: false,
  };

  render() {
    const { isFocused } = this.state;
    return (
      <DatePicker
        onFocusChange={({ focused }) => this.setState({ isFocused: focused })}
        focused={isFocused}
        {...this.props}
      />
    );
  }
}

export default SimpleDatePicker;
